import { Injectable } from "@angular/core";
import {HttpClient,HttpHeaders} from "@angular/common/http"
import { ConfigService } from "../shared/utils/config.service";
import { map } from "rxjs";



@Injectable()
export class CategoryService {

    baseUrl: string = '';

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.baseUrl = configService.getApiURI();
    };

    getCategorys() {
        return this.http.get(this.baseUrl + '/categorys')
            .pipe(map((res:any) => {
                return res
            }));
    }

}